// src/api/useSignUp.js
import { useMutation } from "@tanstack/react-query";
import api from "../utils/api";

const login = (userData) => {
  const { email, password } = userData;

  return api.post("/auth/login", {
    email,
    password,
  });
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useSignInQuery = () => {
  return useMutation({ mutationFn: login });
};
